import type { TickerEventHandler } from "@ekidenfi/ts-sdk";
import { reaction } from "mobx";
import { useEffect, useRef } from "react";

import { useStores } from "@stores";

import { getEkidenSdkClient, isMockMode } from "../sdk";

export const useAllTickersSubscription = () => {
  const { marketStore } = useStores();
  const subscribedRef = useRef(false);

  useEffect(() => {
    if (isMockMode) {
      return;
    }

    const dispose = reaction(
      () => marketStore.allMarkets.length,
      (length) => {
        if (length > 0 && !subscribedRef.current) {
          const ekidenSdkClient = getEkidenSdkClient();

          if (!ekidenSdkClient.publicStream) {
            return;
          }

          const tickerHandler: TickerEventHandler = (msg) => {
            try {
              if (msg.op === "event") {
                marketStore.applyTickerSnapshot(msg.data);
              }
            } catch {}
          };

          const topics = marketStore.allMarkets.map((m) => `ticker.${m.symbol}`);
          ekidenSdkClient.publicStream.subscribeTopics(topics, tickerHandler as any);
          subscribedRef.current = true;
        }
      },
      { fireImmediately: true },
    );

    return () => {
      dispose();
    };
  }, [marketStore]);
};
